module.exports = __webpack_public_path__ + "img/33.2a3204ee.jpg";